import { render, staticRenderFns } from "./blockLeftBottom1.vue?vue&type=template&id=e700e54a&scoped=true&"
import script from "./blockLeftBottom1.vue?vue&type=script&lang=js&"
export * from "./blockLeftBottom1.vue?vue&type=script&lang=js&"
import style0 from "./blockLeftBottom1.vue?vue&type=style&index=0&id=e700e54a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e700e54a",
  null
  
)

export default component.exports